export const rj = {
  // Navigation - मेनू
  nav: {
    dashboard: 'मुख्य पृष्ठ',
    loans: 'लोनो',
    borrowers: 'कस्टमर',
    repledging: 'फिर से गिरवी सामान',
    profitability: 'फायदो',
    analytics: 'रिपोर्ट',
    settings: 'सेटिंग',
    support: 'मदद',
    profile: 'खबर'
  },

  // Common - सामान्य
  common: {
    hello: 'नमस्ते',
    save: 'सेव करो',
    cancel: 'रद्द करो',
    delete: 'हटाओ',
    edit: 'बदलो',
    create: 'बनाओ',
    update: 'अपडेट करें',
    search: 'खोजो',
    filter: 'छांटो',
    apply: 'लागू करो',
    actions: 'चोन',
    loading: 'लोड थाय रह्यो',
    noData: 'कोई खबर नहीं',
    confirmDelete: 'हटाने की पुष्टि करें',
    areYouSure: 'थने पक्को भरोसो है?',
    saveChanges: 'बदलाव सेव करो',
    business: 'व्यापारो',
    logout: 'बाहर आवो',
    createNewLoan: 'नया लोनो बनाओ',
    createRepledging: 'फिर से गिरवी सामान रखें',
    madeWithLove: 'प्यार थी बनायो',
    allRightsReserved: 'सगळा हक राखेला',
    developedBy: 'थारी तरफ थी बनायो',
    developedByCompany: 'Seervi Tech Labs थारी तरफ थी बनायो',
    unknown: 'पता नहीं',
    results: 'कुल',
    prev: 'पिछला',
    next: 'अगला',
    page: 'पेज',
    gallery: 'गैलरी',
    camera: 'कैमरा',
    chooseFromGallery: 'गैलरी से चुनो',
    takePhoto: 'कैमरा से फोटो लो',
    switchToDark: 'डार्क मोड',
    switchToLight: 'लाइट मोड',
    // Amount and Money related
    amount: 'रकम',
    total: 'कुल',
    balance: 'रोकड़',
    paid: 'दियो',
    due: 'रोकड़',
    received: 'मिल्यो',
    given: 'दियो',
    debit: 'जमायो',
    credit: 'उधारो',
    ledger: 'खातो',
    khata: 'खातो बही',
    transaction: 'लेन-देन',
    transactions: 'लेन-देन'
  },

  // Settings Page - सेटिंग पृष्ठ
  settings: {
    title: 'सेटिंग',
    todayRates: 'आज के भाव',
    loanSettings: 'लोनो की सेटिंग',
    pledgeSettings: 'गिरवी सामान की सेटिंग',
    notifications: 'सूचनाएं',
    language: 'भासा',
    appearance: 'दिखावट',
    selectTheme: 'थीम चुणो',
    themeDescription: 'एप खातर लाइट या डार्क मोड चुणो',
    lightThemeHint: 'दिन में इस्तेमाल वास्ते उजालो बैकग्राउंड',
    darkThemeHint: 'कम रोशनी में इस्तेमाल वास्ते डार्क बैकग्राउंड',
    createLoanSetting: 'लोनो सेटिंग बनाओ',
    createPledgeSetting: 'गिरवी सामान सेटिंग बनाओ',
    metal: 'धातु',
    interestRate: 'ब्याज दर (% प्रति महीना)',
    amount: 'रकम',
    amountRange: 'रकम की सीमा',
    name: 'नांव',
    allMetals: 'सभी धातु',
    gold: 'सोना',
    silver: 'चांदी',
    searchPlaceholder: 'धातु, रकम या ब्याज से खोजो...',
    noSettingsFound: 'कोई सेटिंग नहीं मिली',
    noMatchingSettings: 'आपकी खोज से कोई सेटिंग नहीं मिली',
    clickToAdd: 'जोड़ने के लिए यहाँ दबाएं',
    loadingSettings: 'सेटिंग लोड हो रही है...',
    editInterestRate: 'ब्याज दर बदलो',
    deleteSetting: 'सेटिंग हटाओ',
    createLoanInterestSetting: 'लोनो ब्याज सेटिंग बनाओ',
    createNewPledgeSetting: 'नई गिरवी सामान सेटिंग बनाओ',
    editLoanSetting: 'लोनो सेटिंग बदलो',
    minPlaceholder: 'न्यूनतम (जैसे 1000)',
    maxPlaceholder: 'अधिकतम (जैसे 10000)',
    enterName: 'नांव लिखें',
    interestRatePlaceholder: 'जैसे 2.0',
    settingCreatedSuccess: 'सेटिंग सफलतापूर्वक बनाई गई',
    settingUpdatedSuccess: 'सेटिंग सफलतापूर्वक बदली गई',
    settingDeletedSuccess: 'सेटिंग सफलतापूर्वक हटाई गई',
    createSettingBtn: 'सेटिंग बनाओ',
    creatingSetting: 'बनायो जावै है...',
    updateBtn: 'बदलो',
    smsWhatsappTemplates: 'संदेश के नमूने',
    loanExpiryReminder: 'लोनो समाप्ति की याद',
    paymentConfirmation: 'भुगतान की पुष्टि',
    selectLanguage: 'भासा चुनें',
    languageDescription: 'अपनी पसंद की भासा चुनें',
    english: 'अंग्रेज़ी',
    hindi: 'हिंदी',
    marwadi: 'मारवाड़ी',
    languageUpdated: 'भासा सफलतापूर्वक बदली गई',
    // Today's Gold Rates - आज के भाव
    todayRatesTitle: 'सोना-चांदी के आज के भाव',
    createTodayRate: 'भाव जोड़ें',
    goldType: 'धातु का प्रकार',
    todayValue: 'आज की कीमत (₹)',
    perGramValue: '10 ग्राम के',
    selectGoldType: 'धातु प्रकार चुनें',
    gold24K: '24 कैरेट सोना',
    goldSilver: 'चांदी',
    calculatedFrom24K: '24 कैरेट से गणना',
    gold22K: '22 कैरेट सोना',
    gold18K: '18 कैरेट सोना',
    rateValue: 'भाव',
    createRateBtn: 'भाव जोड़ें',
    editRate: 'भाव बदलो',
    deleteRate: 'भाव हटाओ',
    createNewRate: 'नया भाव जोड़ें',
    editRateTitle: 'भाव बदलो',
    noRatesFound: 'कोई भाव नहीं मिल्यो',
    rateCreatedSuccess: 'भाव सफलतापूर्वक जोड़ा गया',
    rateUpdatedSuccess: 'भाव सफलतापूर्वक बदला गया',
    rateDeletedSuccess: 'भाव सफलतापूर्वक हटाया गया'
  },

  // Dashboard - मुख्य पृष्ठ
  dashboard: {
    title: 'मुख्य पृष्ठ',
    quickValuation: 'त्वरित कीमत',
    quickValuationCalculator: 'त्वरित कीमत कैलकुलेटर',
    closedLoans: 'बंद लोनो',
    todayClosedLoans: 'आज बंद लोनो',
    createdLoans: 'कुल लोनो',
    todayCreatedLoans: 'आज नए लोनो',
    overdueAccounts: 'रोकड़ खाते',
    activeLoans: 'चालू लोनो',
    inHandGold: 'दुकान में सोना',
    pledgedGold: 'गिरवी सामान सोना',
    awaitingCollection: 'इंतज़ार में',
    interestEarned: 'कुल ब्याज',
    totalInterestEarned: 'कुल ब्याज मिल्यो',
    lateFees: 'जुर्माना',
    lateFeesCollected: 'जुर्माना मिल्यो',
    averageLoanSize: 'औसत लोनो रकम',
    thisMonth: 'इस महीने',
    activeLoansSubtitle: 'चालू लोनो',
    expiringLoans: 'समाप्त होने वाले लोनो',
    loansNearingExpiry: 'जल्दी समाप्त होने वाले लोनो (अगले 30 दिन)',
    overduePayments: 'रोकड़ भुगतान',
    recentOverduePayments: 'हाल के रोकड़ भुगतान',
    collateralDashboard: 'गिरवी सामान डैशबोर्ड',
    loanId: 'लोनो नंबर',
    customerName: 'कस्टमर का नांव',
    amount: 'रकम',
    expiryDate: 'समाप्ति की तारीख',
    daysOverdue: 'रोकड़ दिन',
    viewDetails: 'पूरा विवरण',
    noExpiringLoans: 'अगले 30 दिनों में कोई लोनो समाप्त नहीं हो रहा',
    noOverduePayments: 'कोई रोकड़ भुगतान नहीं',
    refresh: 'फिर से देखें',
    purity: 'शुद्धता',
    netWeight: 'शुद्ध वजन (ग्राम)',
    lendingRate: 'लोनो दर (प्रति ग्राम)',
    maxLoanValue: 'अधिकतम लोनो रकम',
    calculate: 'गणना करें',
    close: 'बंद करें',
    grams: 'ग्राम',
    perGram: 'प्रति ग्राम',
    // Collateral Details
    inHandOffice: 'दुकान में (ऑफिस)',
    pledged: 'गिरवी सामान',
    awaitingRelease: 'वापसी का इंतज़ार',
    packets: 'पैकेट',
    loanValue: 'लोनो की रकम',
    maximumLoanValue: 'अधिकतम लोनो रकम',
    viewAll: 'सगळा देखो',
    viewLoan: 'लोनो देखो',
    noExpiringLoansCaughtUp: 'बढ़िया! अगले 30 दिनों में कोई लोनो समाप्त कोनी होवै। सब ठीक है।',
    goodMorning: 'सुप्रभात',
    goodAfternoon: 'राम राम',
    goodEvening: 'शुभ संध्या',
    heroSubtitle: 'आज थारे बिज़नेस में कांई हो रह्यो है, इੱथे देखो।',
    businessHealth: 'बिज़नेस हेल्थ',
    healthGood: 'अच्छो',
    healthGoodHint: 'थारो प्रदर्शन अच्छो है',
    healthFair: 'ठीक-ठाक',
    healthFairHint: 'कुछ खातों पर ध्यान दो',
    healthAttention: 'ध्यान दो',
    healthAttentionHint: 'रोकड़ खातों को फॉलो-अप जरूरी है',
    totalActiveLoans: 'कुल चालू लोनो',
    requireAttention: 'ध्यान चाहे',
    interestEarnedChip: 'ब्याज (इस महीने)',
    customers: 'कस्टमर',
    totalLoans: 'कुल लोनो',
    activeLabel: 'सक्रिय',
    vsYesterday: 'काल की तुलना में',
    vsLastMonth: 'पिछले महीने की तुलना में',
    fromLastMonth: 'पिछले महीने सूं'
  },

  // Login Page - प्रवेश पृष्ठ
  login: {
    title: 'प्रवेश',
    signIn: 'अंदर आएं',
    signUp: 'पंजीकरण करें',
    email: 'ईमेल',
    password: 'पासवर्ड',
    firstName: 'पहला नांव',
    lastName: 'उपनांव',
    loginBtn: 'लॉगिन करें',
    signUpBtn: 'पंजीकरण करें',
    dontHaveAccount: 'खातो नहीं है?',
    alreadyHaveAccount: 'पहले से खातो है?',
    signUpHere: 'यहां पंजीकरण करें',
    signInHere: 'यहां लॉगिन करें',
    welcomeBack: 'फिर से स्वागत है!',
    createAccount: 'अपना खातो बनाओ',
    modernLMS: 'आधुनिक लोनो प्रबंधन सॉफ्टवेयर',
    comprehensiveSolution: 'लोनो और कस्टमरों के प्रबंधन के लिए पूर्ण समाधान',
    features: {
      loanManagement: 'लोनो प्रबंधन',
      borrowerTracking: 'कस्टमर रिकॉर्ड',
      collateralManagement: 'गिरवी सामान प्रबंधन',
      profitabilityAnalysis: 'फायदो विश्लेषण',
      advancedAnalytics: 'विस्तृत रिपोर्ट',
      secureReliable: 'सुरक्षित और भरोसेमंद'
    },
    featureDescriptions: {
      loanManagement: 'सभी लोनोों को आसानी से संभालें',
      borrowerTracking: 'सभी कस्टमरों का पूरा विवरण रखें',
      collateralManagement: 'गिरवी सामान सामान की खबर रखें',
      profitabilityAnalysis: 'अपने व्यापारो का फायदो देखें',
      advancedAnalytics: 'विस्तृत रिपोर्ट से खबर पाएं',
      secureReliable: 'आपका डेटा पूरी तरह सुरक्षित है'
    },
    logoutSuccess: 'सफलतापूर्वक बाहर निकले!',
    sessionExpired: 'थारो सेशन खत्म हो गयो। कृपया फिर से लॉगिन करो।',
    businessSetup: 'व्यापारो की खबर',
    businessName: 'दुकान का नांव',
    contactNumber: 'मोबाइल नंबर',
    address: 'पता',
    businessEmail: 'व्यापारो ईमेल (वैकल्पिक)',
    continue: 'आगे बढ़ें',
    backToSignUp: 'पंजीकरण पर वापस'
  },

  // Borrowers Page - कस्टमर पृष्ठ
  borrowers: {
    title: 'कस्टमर',
    listTitle: 'सभी कस्टमर',
    createNewBorrower: 'नया कस्टमर जोड़ें',
    searchPlaceholder: 'कस्टमर खोजो...',
    searchPlaceholderTable: 'नांव या फोन से खोजो',
    addBorrower: 'कस्टमर जोड़ें',
    name: 'नांव',
    phone: 'मोबाइल',
    email: 'ईमेल',
    address: 'पता',
    activeLoans: 'चालू लोनो',
    totalBorrowed: 'कुल लोनो रकम',
    viewDetails: 'पूरा विवरण',
    noBorrowersFound: 'कोई कस्टमर नहीं मिल्यो',
    loadingBorrowers: 'कस्टमर लोड हो रहे हैं...',
    tableHeaders: {
      index: 'क्रमांक',
      name: 'नांव',
      fatherName: 'पिता/पति का नांव',
      phone: 'मोबाइल',
      email: 'ईमेल',
      address: 'पता',
      idProofType: 'पहचान पत्र का प्रकार',
      idNumber: 'पहचान पत्र नंबर',
      viewId: 'पहचान पत्र देखें',
      actions: 'चोन'
    },
    tooltips: {
      viewId: 'पहचान पत्र देखें',
      edit: 'कस्टमर बदलो',
      delete: 'कस्टमर हटाओ'
    },
    tableLabels: {
      noProof: 'उपलब्ध नहीं'
    },
    pagination: {
      label: 'पृष्ठ',
      of: 'में से',
      prev: 'पिछला',
      next: 'अगला'
    },
    deleteModal: {
      title: 'पुष्टि करें',
      messageStart: 'क्या आप सच में हटाना चाहते हैं',
      cancel: 'रद्द करो',
      confirm: 'हटाओ'
    },
    editModal: {
      title: 'कस्टमर बदलो',
      close: 'बंद करें'
    },
    form: {
      fullNameLabel: 'पूरा नांव *',
      fatherNameLabel: 'पिता/पति का नांव *',
      contactNumberLabel: 'मोबाइल नंबर *',
      idProofTypeLabel: 'पहचान पत्र का प्रकार *',
      selectIdProofType: 'पहचान पत्र चुनें',
      idProofNumberLabel: 'पहचान पत्र नंबर *',
      emailLabel: 'ईमेल',
      addressLabel: 'पता *',
      uploadTitle: 'पहचान पत्र की फोटो (अधिकतम 2)',
      currentPhotosTitle: 'मौजूदा फोटो:',
      uploadHint: 'नई फोटो डालने के लिए यहाँ दबाएं',
      uploadLimit: 'JPEG, PNG (अधिकतम 5MB)',
      newPhotoLabel: 'नई',
      removePhoto: 'फोटो हटाओ'
    },
    upload: {
      maxPhotosError: 'अधिकतम 2 फोटो ही जोड़ सकते हैं',
      invalidFileType: 'कृपया सही फोटो चुनें (JPEG, PNG)',
      fileTooLarge: 'हर फोटो 5MB से कम होनी चाहिए',
      success: 'फोटो सफलतापूर्वक डाली गई!',
      failure: 'फोटो डालने में दिक्कत आई',
      selectedSuffix: 'नई फोटो चुनी गई'
    },
    buttons: {
      cancel: 'रद्द करो',
      update: 'कस्टमर बदलो'
    },
    status: {
      uploading: 'फोटो डाली जा रही है...'
    },
    toast: {
      updateSuccess: 'कस्टमर बदल गया',
      updateError: 'कस्टमर नहीं बदला',
      deleteSuccess: 'कस्टमर हटाया गया',
      deleteError: 'कस्टमर हटाने में दिक्कत आई',
      loadError: 'कस्टमर लोड नहीं हो पाए'
    },
    imageModal: {
      noImages: 'कोई पहचान पत्र की फोटो नहीं',
      failedToLoad: 'फोटो लोड नहीं हो पाई'
    }
  },

  // Loans Page - लोनो पृष्ठ
  loans: {
    title: 'सभी लोनो',
    loanId: 'लोनो नंबर',
    borrowerName: 'कस्टमर का नांव',
    amount: 'रकम',
    interestRate: 'ब्याज दर',
    startDate: 'शुरू होने की तारीख',
    endDate: 'समाप्ति की तारीख',
    status: 'स्थिति',
    actions: 'चोन',
    active: 'चालू',
    closed: 'बंद',
    overdue: 'रोकड़',
    viewDetails: 'पूरा विवरण',
    noLoansFound: 'कोई लोनो नहीं मिल्यो',
    searchPlaceholder: 'लोनो खोजो...',
    filterByStatus: 'स्थिति से छांटो',
    allLoans: 'सभी लोनो',
    searchByLoanPlaceholder: 'लोनो नंबर, ID या कस्टमर से खोजो',
    serialSearchPlaceholder: 'सीरियल नंबर से खोजो',
    dateFilterLabel: 'तारीख',
    dateFieldLabel: 'तारीख',
    allStatus: 'सगळी स्थिति',
    filterAction: 'फिल्टर',
    resetAction: 'रीसेट',
    todayLabel: 'आज',
    dateFilterOptions: {
      all: 'सगळी तारीखां',
      date: 'एक तारीख',
      month: 'महीने सूं',
      year: 'साल सूं',
      range: 'तारीख सीमा'
    },
    dateTips: {
      single: 'उस दिन के लोनो देखण खातिर तारीख चुनो।',
      range: 'सीमा में लोनो देखण खातिर शुरू अर अंत तारीख चुनो।',
      month: 'उस महीने के लोनो देखण खातिर महीनो चुनो।',
      year: 'उस साल के लोनो देखण खातिर साल चुनो।'
    },
    fromDateLabel: 'सूं',
    toDateLabel: 'तांई',
    clearDateFilter: 'साफ',
    closeDateFilter: 'बंद करो',
    statusFilterLabel: 'स्थिति',
    collateralFilterLabel: 'गिरवी सामान स्थिति',
    statusOptions: {
      all: 'सभी',
      awaited: 'आने वाला',
      active: 'चालू',
      completed: 'पूरा'
    },
    collateralStatusOptions: {
      all: 'सभी',
      inHand: 'दुकान में',
      pledged: 'गिरवी सामान',
      awaiting: 'इंतज़ार में',
      handover: 'वापस दियो'
    },
    tableHeaders: {
      loanId: 'लोनो नंबर',
      serialNumber: 'सीरियल नंबर',
      customer: 'कस्टमर',
      relation: 'पिता/पति का नांव',
      contactNumber: 'मोबाइल नंबर',
      principal: 'मूल रकम (₹)',
      status: 'स्थिति',
      collateralStatus: 'गिरवी सामान स्थिति',
      packetPlace: 'पैकेट की जगह',
      created: 'बनने की तारीख',
      actions: 'चोन'
    },
    loadingMessage: 'लोनो लोड हो रहे हैं...',
    emptyFiltered: 'आपकी खोज से कोई लोनो नहीं मिल्यो',
    toast: {
      deleteSuccess: 'लोनो हटा दियो',
      deleteError: 'लोनो नहीं हटा'
    },
    messages: {
      loadError: 'लोनो लोड नहीं हो पाए',
      searchMinChars: 'खोजण खातिर कम से कम 2 अक्षर लिखो'
    },
    deleteModal: {
      title: 'पुष्टि करें',
      messageStart: 'क्या आप यह लोनो हटाना चाहते हैं',
      warning: 'इससे जुड़े सभी गिरवी सामान रिकॉर्ड और भुगतान भी हट जाएंगे।',
      cancel: 'रद्द करो',
      confirm: 'हटाओ'
    },
    tooltips: {
      delete: 'लोनो हटाओ'
    },
    statusLabels: {
      awaited: 'आने वाला',
      active: 'चालू',
      completed: 'पूरा',
      default: 'आने वाला'
    },
    collateralStatusLabels: {
      inHand: 'दुकान में',
      pledged: 'गिरवी सामान',
      awaiting: 'इंतज़ार में',
      handover: 'वापस दियो',
      default: 'पता नहीं'
    },
    labels: {
      serialMissing: '-',
      na: 'पता नहीं'
    }
  },

  // Profile Page - खबर पृष्ठ
  // Support Page - मदद पृष्ठ
  // Create Borrower Page - नया कस्टमर बनाओ
  createBorrower: {
    title: 'नया कस्टमर बनाओ',
    backToList: 'कस्टमर सूची में वापस',
    // Form Fields
    fullName: 'पूरा नांव',
    fullNamePlaceholder: 'पूरा नांव दर्ज करें',
    fatherHusbandName: 'पिता/पति/आश्रित का नांव',
    fatherHusbandNamePlaceholder: 'पिता/पति/आश्रित का नांव दर्ज करें',
    phoneNumber: 'फोन नंबर',
    phoneNumberPlaceholder: 'फोन नंबर दर्ज करें',
    idProofType: 'आईडी प्रूफ प्रकार',
    aadhaarCard: 'आधार कार्ड',
    panCard: 'पैन कार्ड',
    voterId: 'वोटर आईडी',
    drivingLicense: 'ड्राइविंग लाइसेंस',
    idProofNumber: 'आईडी प्रूफ नंबर',
    idProofNumberPlaceholder: 'आईडी नंबर दर्ज करें',
    email: 'ईमेल पता (वैकल्पिक)',
    emailPlaceholder: 'ईमेल पता दर्ज करें',
    fullAddress: 'पूरा पता',
    fullAddressPlaceholder: 'पूरा पता दर्ज करें',
    uploadIdProof: 'आईडी प्रूफ फोटो अपलोड करें (अधिकतम 2)',
    clickToUpload: 'फोटो अपलोड के लिए क्लिक करें',
    supportedFormats: 'JPEG, PNG (अधिकतम 5MB प्रत्येक)',
    // Buttons
    saveBorrower: 'कस्टमर सेव करो',
    saving: 'सुरक्षित हो रहा है...',
    cancel: 'रद्द करो',
    // Messages
    borrowerCreatedSuccess: 'कस्टमर सफलतापूर्वक बनाया गया!',
    uploadFailed: 'फोटो अपलोड विफल',
    fillAllFields: 'कृपया सभी आवश्यक फ़ील्ड भरें'
  },

  support: {
    title: 'मदद',
    subtitle: 'जब आपको हमारी जरूरत हो, हम हमेशा आपके करीब हैं। अपने सवाल के लिए सबसे उपयुक्त संपर्क चोन चुनें—चाहे वह डेटा स्पष्टीकरण हो या गहरी तकनीकी समस्या।',
    dataAccountAssistance: 'डेटा और खातो सहायता',
    dataAccountDesc: 'कस्टमर डेटा, लोनो रिकॉर्ड, या खातो प्रबंधन से संबंधित सवाल। महेंद्र व्यवसाय के घंटों के दौरान किसी भी परिचालन सवाल को हल करने के लिए उपलब्ध हैं।',
    primaryContact: 'प्राथमिक संपर्क',
    platformTechnicalSupport: 'प्लेटफॉर्म और तकनीकी सहायता',
    platformTechnicalDesc: 'लॉगिन समस्याएं, ऐप एरर, या परफॉर्मेंस की चिंताएं? त्वरित समाधान के लिए Seervi Tech Labs इंजीनियरिंग डेस्क से संपर्क करें।',
    technicalDesk: 'तकनीकी डेस्क',
    getHelp: 'मदद लें',
    contactUs: 'हमसे संपर्क करें',
    email: 'ईमेल',
    phone: 'फोन',
    businessHours: 'काम के घंटे',
    mondayToFriday: 'सोमवार से शुक्रवार: सुबह 9:00 - शाम 6:00',
    faq: 'अक्सर पूछे जाने वाले सवाल',
    sendMessage: 'संदेश भेजें',
    yourMessage: 'आपका संदेश',
    messageSent: 'संदेश सफलतापूर्वक भेजा गया'
  },

  // Profitability Page - फायदो पृष्ठ
  profitability: {
    title: 'फायदो',
    purpose: 'म्हारे व्यापार ने असल में कितनो पैसो कमायो?',
    businessSummary: 'व्यापार सारांश',
    summaryLastMonth: 'पिछलो महीनो',
    summaryLastQuarter: 'पिछली तिमाही',
    summaryLastYear: 'पिछलो साल',
    summaryPriorPeriod: 'पिछली अवधि',
    summaryProfitIncreased: 'फायदो {period} की तुलना में {percent}% बढ़्यो।',
    summaryProfitDecreased: 'फायदो {period} की तुलना में {percent}% घट्यो।',
    summaryProfitUnchanged: 'फायदो {period} की तुलना में समान है।',
    summaryNetProfit: 'इस अवधि को शुद्ध फायदो {amount} है।',
    summaryOutstandingInterest: 'बाकी ब्याज {amount} है।',
    summaryHighestMonth: 'सबसूं ज्यादा कमाई को महीनो {month} है ({amount})।',
    thisMonth: 'इस महीने',
    thisQuarter: 'इस तिमाही',
    thisYear: 'इस साल',
    allTime: 'सगळो',
    grossIncome: 'कुल आमदनी',
    totalExpenses: 'कुल खर्च (बैंक ब्याज)',
    netProfit: 'शुद्ध फायदो',
    netLoss: 'शुद्ध घाटो',
    fromLastMonth: 'पिछलो महीनो तै',
    fromLastQuarter: 'पिछली तिमाही तै',
    fromLastYear: 'पिछलो साल तै',
    fromPriorPeriod: 'पिछली अवधि तै',
    interestEarned: 'ब्याज आमदनी',
    pledgeInterestPaid: 'बैंक ब्याज खर्च',
    bankInterestPaid: 'बैंक ब्याज खर्च',
    profitMargin: 'फायदो प्रतिशत',
    month: 'महीनो',
    financialPosition: 'पैसा को हाल',
    moneyWithCustomers: 'कस्टमर के पास पैसो',
    moneyBorrowedFromBank: 'बैंक सूं उधार',
    ownCapitalInvested: 'आपणी पूंजी',
    outstandingInterestYetToCollect: 'बाकी ब्याज',
    profitInsights: 'फायदो जानकारी',
    highestProfitMonth: 'सबसूं ज्यादा फायदो महीनो',
    lowestProfitMonth: 'सबसूं कम फायदो महीनो',
    averageMonthlyProfit: 'औसत मासिक फायदो',
    totalProfitSelected: 'कुल फायदो (चुनी अवधि)',
    monthlyFinancialTable: 'मासिक वित्तीय तालिका',
    monthlyRevenue: 'मासिक आमदनी',
    viewReport: 'रिपोर्ट देखो',
    monthlyProfitabilityTrend: 'मासिक फायदोप्रदता रुझान',
    monthlyBreakdownOverview: 'मासिक विवरण सारांश',
    noChartData: 'चुनी हुई अवधि के लिए कोई चार्ट डेटा नहीं'
  },

  // Analytics Page - रिपोर्ट पृष्ठ
  analytics: {
    title: 'रिपोर्ट और विश्लेषण',
    purpose: 'म्हारो व्यापार कितनो स्वस्थ अर कुशल है?',
    businessSummary: 'व्यापार सारांश',
    businessPerformance: 'व्यापार परफॉर्मेंस',
    portfolioHealth: 'पोर्टफोलियो हेल्थ',
    riskLow: 'कम',
    riskMedium: 'मध्यम',
    riskHigh: 'ज्यादा',
    summaryCollectionRate: 'वसूली दर {percent}% है।',
    summaryPortfolioRisk: 'पोर्टफोलियो जोखिम {level} है।',
    summaryOverdueOne: '{count} लोनो ओवरड्यू है।',
    summaryOverdueMany: '{count} लोनो ओवरड्यू हैं।',
    summaryActivePortfolio: 'एक्टिव पोर्टफोलियो वैल्यू {amount} है।',
    summaryLoanGrowthUp: 'लोनो ग्रोथ पिछली अवधि की तुलना में {percent}% बढ़ी।',
    summaryLoanGrowthDown: 'लोनो ग्रोथ पिछली अवधि की तुलना में {percent}% घटी।',
    summaryLoanGrowthFlat: 'लोनो ग्रोथ पिछली अवधि की तुलना में समान है।',
    last7Days: 'पिछले 7 दिन',
    last30Days: 'पिछले 30 दिन',
    last90Days: 'पिछले 90 दिन',
    lastYear: 'पिछला साल',
    exportReport: 'रिपोर्ट निर्यात करें',
    loanGrowth: 'लोनो ग्रोथ',
    activePortfolioValue: 'एक्टिव पोर्टफोलियो',
    collectionRate: 'वसूली दर',
    riskScore: 'जोखिम स्कोर',
    portfolioSummary: 'पोर्टफोलियो सारांश',
    activeLoans: 'एक्टिव लोनो',
    completedLoans: 'पूरा लोनो',
    overdueLoans: 'ओवरड्यू लोनो',
    outstandingPrincipal: 'बाकी मूलधन',
    collectionPerformance: 'वसूली परफॉर्मेंस',
    collections: 'वसूली',
    recoveryRate: 'रिकवरी दर',
    latePayments: 'देर सूं पेमेंट',
    customerInsights: 'कस्टमर जानकारी',
    newCustomers: 'नए कस्टमर',
    repeatCustomers: 'दोबारा कस्टमर',
    averageLoanSize: 'औसत लोनो साइज',
    loanStatusDistribution: 'लोनो स्थिति वितरण',
    awaited: 'प्रतीक्षित',
    active: 'एक्टिव',
    completed: 'पूर्ण',
    totalRevenue: 'कुल आमदनी',
    newLoans: 'नए लोनो',
    vsLastPeriod: 'पिछली अवधि की तुलना में',
    revenueTrend: 'आमदनी का रुझान',
    detailedPerformanceReport: 'विस्तृत प्रदर्शन रिपोर्ट',
    comprehensiveAnalysis: 'लोनो प्रदर्शन और वित्तीय मेट्रिक्स का व्यापक विश्लेषण',
    metric: 'मेट्रिक',
    currentPeriod: 'वर्तमान अवधि',
    previousPeriod: 'पिछली अवधि',
    change: 'बदलाव'
  },

  // Create Loan Page - नया लोनो बनाओ
  createLoan: {
    title: 'नया लोनो बनाओ',
    subtitle: 'नया लोनो बनाने के लिए चरणों का पालन करें।',
    // Steps
    steps: {
      borrower: 'कस्टमर',
      collateral: 'गिरवी सामान',
      terms: 'शर्तें',
      confirm: 'पुष्टि करें'
    },
    // Common Units
    units: {
      grams: 'ग्राम',
      perGram: 'प्रति ग्राम',
      perMonth: 'प्रति महीना',
      months: 'महीने',
      rupees: '₹'
    },
    // Step 1: Borrower Selection
    step1: {
      title: 'चरण 1: कस्टमर चुनें या बनाओ',
      searchExistingBorrower: 'मौजूदा कस्टमर खोजो',
      searchPlaceholder: 'नांव या फोन नंबर लिखना शुरू करें...',
      selectedBorrower: 'चुना गया कस्टमर',
      name: 'नांव',
      phone: 'फोन',
      email: 'ईमेल',
      orNewCustomer: 'या, अगर यह नया कस्टमर है:',
      createNewBorrower: 'नया कस्टमर बनाओ'
    },
    // Step 2: Collateral Details
    step2: {
      title: 'चरण 2: गिरवी सामान विवरण',
      loanFor: 'लोनो किसके लिए',
      todayMarketRates: '📊 आज के बाजार भाव',
      gold24k: '24 कैरेट सोना (10 ग्राम)',
      gold22k: '22 कैरेट सोना (10 ग्राम)',
      gold18k: '18 कैरेट सोना (10 ग्राम)',
      silver: 'चांदी (1 किलो)',
      serialNumber: 'सीरियल नंबर (वैकल्पिक)',
      serialNumberPlaceholder: 'जैसे: SN123456',
      creatingDate: 'लोनो बनावण री तारीख',
      metalType: 'धातु का प्रकार',
      gold: 'सोना',
      silverOption: 'चांदी',
      itemDescription: 'सामान का विवरण',
      itemDescriptionPlaceholder: 'गिरवी सामान का विवरण (जैसे: सोने की चेन, चांदी की चूड़ियां)',
      purity: 'शुद्धता/कैरेट',
      purity24k: '24k (24 कैरेट)',
      purity22k: '22k (22 कैरेट)',
      purity18k: '18k (18 कैरेट)',
      purityPure: 'शुद्ध',
      grossWeight: 'कुल वजन (ग्राम में)',
      grossWeightPlaceholder: 'जैसे: 55.5',
      netWeight: 'शुद्ध वजन (ग्राम में)',
      netWeightPlaceholder: 'जैसे: 50.5',
      presentValue: 'वर्तमान मूल्य रकम (₹)',
      presentValuePlaceholder: 'जैसे: 325000',
      autoCalculated: 'स्वचालित गणना',
      collateralPhotos: 'गिरवी सामान फोटो',
      uploadPhotos: 'फोटो अपलोड करें',
      uploadPhotosHint: 'गिरवी सामान की फोटो अपलोड करें (वैकल्पिक)',
      clickToUpload: 'अपलोड के लिए क्लिक करें',
      or: 'या',
      dragDrop: 'यहाँ खींचें और छोड़ें',
      supportedFormats: 'PNG, JPG, JPEG (अधिकतम 5MB प्रत्येक)',
      photoPreview: 'फोटो पूर्वावलोकन'
    },
    // Step 3: Loan Terms
    step3: {
      title: 'चरण 3: लोनो की शर्तें',
      marketValue: 'बाजार मूल्य',
      maxEligibleAmount: 'अधिकतम योग्य रकम',
      ltvRate: 'एलटीवी दर (प्रति ग्राम)',
      ltvRatePlaceholder: '6500',
      autoFilledLTV: '💡 स्वचालित रूप से भरा गया',
      lendingRate: 'लोनो दर (प्रति ग्राम)',
      lendingRatePlaceholder: 'प्रति ग्राम दर',
      finalDisbursedAmount: 'अंतिम दी जाने वाली रकम (₹)',
      disbursedAmount: 'दी जाने वाली रकम (₹)',
      disbursedAmountPlaceholder: 'जैसे: 325000',
      interestRate: 'ब्याज दर (% प्रति महीना)',
      interestRatePlaceholder: '2.5',
      tenure: 'अवधि (महीनों में)',
      tenurePlaceholder: '12',
      calculatedInterest: 'गणना किया गया ब्याज',
      totalRepayment: 'कुल वापसी रकम'
    },
    // Step 4: Confirmation
    step4: {
      title: 'चरण 4: पुष्टि',
      reviewLoanDetails: 'लोनो विवरण की समीक्षा करें',
      reviewMessage: 'कृपया लोनो की पुष्टि करने से पहले सभी विवरण की समीक्षा करें। पुष्टि करने के बाद, लोनो सिस्टम में बन जाएगा।',
      borrowerDetails: 'कस्टमर विवरण',
      collateralDetails: 'गिरवी सामान विवरण',
      loanTerms: 'लोनो की शर्तें',
      noBorrowerSelected: '⚠️ कोई कस्टमर नहीं चुना गया। कृपया वापस जाएं और कस्टमर चुनें।',
      name: 'नांव',
      phone: 'फोन',
      email: 'ईमेल',
      address: 'पता',
      metalType: 'धातु का प्रकार',
      purityKarat: 'शुद्धता/कैरेट',
      grossWeight: 'कुल वजन',
      netWeight: 'शुद्ध वजन',
      presentValueAmount: 'वर्तमान मूल्य रकम',
      itemDescription: 'सामान का विवरण',
      serialNumber: 'सीरियल नंबर',
      creatingDate: 'लोनो बनावण री तारीख',
      ltvRate: 'एलटीवी दर',
      lendingRate: 'लोनो दर',
      disbursedAmount: 'दी जाने वाली रकम',
      interestRate: 'ब्याज दर',
      tenure: 'अवधि',
      months: 'महीने',
      perMonth: 'प्रति महीना',
      perGram: 'प्रति ग्राम',
      calculatedInterest: 'गणना किया गया ब्याज',
      totalRepayment: 'कुल वापसी रकम',
      photos: 'फोटो',
      confirmCreateLoan: 'पुष्टि करें और लोनो बनाओ'
    },
    // Buttons
    buttons: {
      back: 'पीछे',
      next: 'आगे',
      nextStep: 'अगला चरण',
      previous: 'पिछला',
      createLoan: 'लोनो बनाओ',
      confirmCreateLoan: 'पुष्टि करें और लोनो बनाओ',
      creating: 'बन रहा है...'
    },
    // Messages
    messages: {
      selectBorrower: 'कृपया कस्टमर चुनें या नया कस्टमर बनाओ',
      fillCollateralDetails: 'कृपया सभी आवश्यक गिरवी सामान विवरण भरें',
      selectCreatingDate: 'कृपया सही लोनो बनावण री तारीख चुनो',
      fillLoanTerms: 'कृपया सभी लोनो की शर्तें भरें',
      disbursedAmountExceeds: 'दी जाने वाली रकम अधिकतम योग्य रकम से अधिक नहीं हो सकती',
      uploadFailed: 'फोटो अपलोड विफल। कृपया पुनः प्रयास करें।',
      loanCreatedSuccess: 'लोनो सफलतापूर्वक बनाया गया!',
      borrowerSelected: 'कस्टमर चुना गया। अब गिरवी सामान विवरण जोड़ें।'
    }
  },

  // Create Pledge Page - नई गिरवी सामान बनाओ  
  createPledge: {
    title: 'नई गिरवी सामान बनाओ',
    backToCollateral: 'गिरवी सामान सूची में वापस',
    // Form Fields
    loanId: 'लोनो नंबर',
    loanNumber: 'लोनो नंबर',
    loanIdPlaceholder: 'लोनो नंबर, कस्टमर नांव, या फोन से खोजो...',
    selectedLoan: 'चुना गया लोनो',
    borrower: 'कस्टमर',
    phone: 'फोन',
    amount: 'रकम',
    serialNumber: 'सीरियल नंबर',
    pledgedTo: 'कहाँ गिरवी सामान',
    pledgedToPlaceholder: 'बैंक या संस्था का नांव',
    searchBank: 'बैंक खोजो...',
    selectOrType: 'सूची से चुनें या नया नांव लिखें',
    pledgeAmount: 'गिरवी सामान रकम (₹)',
    pledgeAmountPlaceholder: 'गिरवी सामान रकम दर्ज करें',
    interestRate: 'ब्याज दर (% प्रति महीना)',
    interestRatePlaceholder: 'ब्याज दर',
    pledgeDate: 'गिरवी सामान की तारीख',
    searchingLoans: 'लोनो खोज रिया हैं...',
    noLoansFound: 'कोई लोनो कोनी मिल्यो',
    maturityDate: 'वापसी की तारीख',
    uploadDocument: 'दस्तावेज़ अपलोड करें',
    uploadDocumentHint: 'गिरवी सामान दस्तावेज़ अपलोड करें (वैकल्पिक)',
    clickToUpload: 'अपलोड के लिए क्लिक करें',
    or: 'या',
    dragDrop: 'यहाँ खींचें और छोड़ें',
    supportedFormats: 'PDF, PNG, JPG, JPEG (अधिकतम 10MB)',
    documentPreview: 'दस्तावेज़ पूर्वावलोकन',
    // Buttons
    buttons: {
      save: 'सेव करो',
      creating: 'बन रहा है...',
      uploading: 'अपलोड थाय रह्यो...',
      createPledge: 'गिरवी सामान बनाओ'
    },
    // Messages
    messages: {
      selectLoan: 'कृपया लोनो चुनें',
      fillAllFields: 'कृपया सभी आवश्यक फ़ील्ड भरें',
      pledgeCreatedSuccess: 'गिरवी सामान सफलतापूर्वक बनाई गई!',
      uploadFailed: 'दस्तावेज़ अपलोड विफल। कृपया पुनः प्रयास करें।',
      createFailed: 'गिरवी सामान बनाने में विफल',
      alreadyPledged: 'यो आइटम पहले से गिरवी है'
    }
  },

  // Collateral/Re-pledging Page - फिर से गिरवी सामान पृष्ठ
  collateral: {
    title: 'फिर से गिरवी सामान',
    listTitle: 'सभी फिर से गिरवी सामान',
    createNewPledge: 'नई गिरवी सामान रखें',
    bankSummary: {
      button: 'बैंक सारांश',
      title: 'बैंक सारांश',
      subtitle: 'बैंक अनुसार गिरवी सामान रो विवरण',
      loading: 'बैंक सारांश लोड हो रह्यो है...',
      loadError: 'बैंक सारांश लोड नहीं हो पायो',
      retry: 'फिर कोशिश करो',
      emptyTitle: 'कोई गिरवी सामान नहीं मिली',
      emptyMessage: 'सारांश देखावण खातर अभी कोई गिरवी सामान नहीं है।',
      perMonth: 'प्रति महीनो',
      pledgedLoans: 'गिरवी लोनो',
      pledgedAmount: 'गिरवी रकम',
      interestPaid: 'भुगतान ब्याज',
      interestDue: 'देय ब्याज',
      viewLoans: '{count} लोनो देखो →',
      totalSummary: 'कुल सारांश',
      activeTotalSummary: 'बैंक में सक्रिय',
      activeTotalHint: 'केवल PLEDGED + AWAITING',
      allTimeTotalSummary: 'कुल अब तक',
      allTimeTotalHint: 'HISTORY',
      loansBadge: '{count} लोनो',
      totalLoans: 'कुल लोनो',
      totalPledgedAmount: 'कुल गिरवी रकम',
      totalInterestPaid: 'कुल भुगतान ब्याज',
      totalInterestDue: 'कुल देय ब्याज'
    },
    pledgeId: 'गिरवी सामान नंबर',
    itemName: 'सामान का नांव',
    weight: 'वजन',
    value: 'कीमत',
    status: 'स्थिति',
    pledgedDate: 'गिरवी सामान की तारीख',
    viewDetails: 'पूरा विवरण',
    noPledgesFound: 'कोई गिरवी सामान नहीं मिली',
    searchPlaceholder: 'गिरवी सामान खोजो...',
    searchPlaceholderDetailed: 'कस्टमर, लोनो नंबर या कहाँ गिरवी सामान है उससे खोजो...',
    filterLabel: 'सभी स्थिति',
    tableHeaders: {
      loanId: 'लोनो नंबर',
      borrower: 'कस्टमर',
      pledgedTo: 'कहाँ गिरवी सामान',
      pledgeAmount: 'गिरवी सामान रकम',
      interestRate: 'ब्याज दर',
      pledgeDate: 'गिरवी सामान की तारीख',
      maturityDate: 'समाप्ति की तारीख',
      status: 'स्थिति'
    },
    statusOptions: {
      all: 'सभी स्थिति',
      inHand: 'दुकान में',
      pledged: 'गिरवी सामान',
      awaiting: 'इंतज़ार में',
      handover: 'वापस दियो'
    },
    loadingMessage: 'गिरवी सामान लोड हो रही है...',
    emptyState: 'कोई गिरवी सामान नहीं मिली',
    errors: {
      noBusinessSelected: 'कोई दुकान नहीं चुनी',
      loadFailed: 'गिरवी सामान लोड नहीं हो पाई',
      updateFailed: 'स्थिति बदलने में दिक्कत आई'
    },
    statusModal: {
      title: 'स्थिति बदलो',
      messageStart: 'क्या आप स्थिति बदलना चाहते हैं',
      from: 'से',
      to: 'को',
      defaultName: 'इस गिरवी सामान',
      cancel: 'रद्द करो',
      confirm: 'स्थिति बदलो',
      updating: 'बदला जा रहा है...'
    }
  },

  // Loan Details Page - लोनो विवरण पृष्ठ
  loanDetails: {
    loading: 'लोनो खबर लोड हो रही है...',
    notFound: 'लोनो नहीं मिल्यो',
    backToList: 'लोनो सूची पर वापस',
    back: 'वापस',
    recordPayment: 'भुगतान जोड़ें',
    additionalLoan: 'अतिरिक्त लोनो',
    additionalAdvance: 'अतिरिक्त एडवांस',
    roundOff: 'राउंड-ऑफ',
    settlementAdjustment: 'सेटलमेंट समायोजन',
    paymentAllocation: 'भुगतान बांट',
    additionalDisbursement: 'अतिरिक्त रकम दियो',
    initialDisbursement: 'पहली रकम दियो',
    payment: 'भुगतान',
    advanceLedger: 'लोनो एडवांस',
    advanceDate: 'एडवांस तारीख',
    advanceAmount: 'एडवांस रकम',
    maximumEligibleAmount: 'अधिकतम योग्य रकम',
    currentTotalAdvanced: 'अभी तक कुल एडवांस',
    currentInterestRate: 'चालू ब्याज दर',
    remainingEligibleAmount: 'बाकी योग्य रकम',
    outstandingPrincipal: 'बाकी मूल रकम',
    outstandingInterest: 'बाकी ब्याज',
    noAdvances: 'कोई एडवांस रिकॉर्ड नहीं',
    saveAdditionalLoan: 'लोनो जोड़ो',
    addingAdditionalLoan: 'जोड़्यो जा रह्यो...',
    summaryTitle: 'लोनो सारांश',
    borrowerLabel: 'कस्टमर',
    principalLabel: 'लोनो रकम',
    interestLabel: 'जमायो ब्याज',
    durationLabel: 'लोनो अवधि',
    durationUnit: 'महीने',
    durationSingleUnit: 'महीना',
    interestRow: 'ब्याज',
    interestPerMonth: 'प्रति महीना',
    principalOutstanding: 'लोनो रकम',
    totalDue: 'कुल देय',
    borrowerCardTitle: 'कस्टमर विवरण',
    borrowerContact: 'मोबाइल नंबर',
    borrowerEmail: 'ईमेल',
    borrowerAddress: 'पता',
    pledgeCardTitle: 'गिरवी सामान विवरण',
    pledgeStatus: 'गिरवी सामान स्थिति',
    pledgedTo: 'कहाँ गिरवी सामान',
    pledgeDate: 'गिरवी सामान की तारीख',
    maturityDate: 'समाप्ति की तारीख',
    collateralStatus: 'स्थिति',
    paymentHistory: 'भुगतान का रिकॉर्ड',
    // Transaction Ledger (Khata)
    transactionLedger: 'लेन-देन खातो (खातो)',
    ledgerTitle: 'खातो बही',
    loadingTransactions: 'लेन-देन लोड थाय रह्यो...',
    noTransactionsFound: 'कोई लेन-देन नहीं मिल्यो',
    ledgerHeaders: {
      date: 'तारीख',
      description: 'विवरण',
      reference: 'संदर्भ',
      paymentMethod: 'भुगतान का तरीका',
      roundOff: 'राउंड-ऑफ',
      amount: 'रकम'
    },
    // Item Details
    itemDetails: 'सामान का विवरण',
    metalType: 'धातु का प्रकार',
    purity: 'शुद्धता',
    grossWeight: 'कुल वजन',
    netWeight: 'शुद्ध वजन',
    presentValue: 'वर्तमान मूल्य',
    lendingRate: 'लोनो दर',
    serialNumber: 'सीरियल नंबर',
    collateralImage: 'गिरवी सामान फोटो',
    // Collateral Status
    collateralStatusValues: {
      IN_HAND: 'दुकान में',
      PLEDGED: 'गिरवी सामान',
      AWAITING: 'वापसी का इंतज़ार',
      HANDOVER: 'वापस दियो'
    },
    paymentTable: {
      noPayments: 'अभी तक कोई भुगतान नहीं',
      headers: {
        date: 'तारीख',
        amount: 'रकम',
        interest: 'ब्याज',
        penalty: 'जुर्माना',
        mode: 'भुगतान का तरीका',
        reference: 'संदर्भ',
        notes: 'नोट',
        actions: 'चोन'
      },
      viewReceipt: 'रसीद देखें',
      delete: 'हटाओ'
    },
    paymentModal: {
      title: 'भुगतान जोड़ें',
      paymentSummary: 'भुगतान सारांश',
      totalAmountDue: 'कुल देय रकम',
      totalPaid: 'कुल दियो',
      outstandingBalance: 'रोकड़ रकम',
      roundOffAmount: 'राउंड-ऑफ रकम (स्वचालित)',
      paymentAmount: 'भुगतान रकम',
      enterPaymentAmount: 'भुगतान रकम दर्ज करें',
      maximum: 'अधिकतम',
      paymentMethod: 'भुगतान का तरीका',
      referenceNumber: 'संदर्भ नंबर (वैकल्पिक)',
      enterReference: 'संदर्भ/लेन-देन नंबर दर्ज करें',
      description: 'विवरण',
      interestPayment: 'ब्याज भुगतान',
      loanDisbursed: 'लोनो दियो',
      principalPayment: 'मूल रकम भुगतान',
      partialPayment: 'आंशिक भुगतान',
      cancel: 'रद्द करो',
      recordPayment: 'भुगतान दर्ज करें',
      recording: 'दर्ज हो रहा है...',
      paymentType: 'भुगतान रो प्रकार',
      regularPayment: 'नियमित भुगतान',
      interestOnly: 'केवल ब्याज',
      fullSettlement: 'पूरो भुगतान',
      interestAllocation: 'ब्याज में',
      principalAllocation: 'मूल रकम में',
      expectedSettlement: 'पूरो भुगतान रकम',
      enterDescription: 'वैकल्पिक नोट',
      // Payment Methods
      cash: 'नकद',
      upi: 'यूपीआई',
      bankTransfer: 'बैंक ट्रांसफर',
      cheque: 'चेक',
      card: 'कार्ड',
      // Old fields for backward compatibility
      amountLabel: 'रकम',
      methodLabel: 'भुगतान का तरीका',
      descriptionLabel: 'विवरण',
      referenceLabel: 'संदर्भ नंबर',
      close: 'बंद करें',
      save: 'भुगतान सेव करो'
    },
    statusModal: {
      title: 'गिरवी सामान स्थिति बदलो',
      message: 'क्या गिरवी सामान सामान वापस आ गया है?',
      cancel: 'रद्द करो',
      confirm: 'पुष्टि करें',
      updating: 'बदला जा रहा है...'
    },
    deleteLoanModal: {
      title: 'लोनो हटाओ',
      message: 'क्या आप यह लोनो हटाना चाहते हैं? यह वापस नहीं हो सकता।',
      confirm: 'लोनो हटाओ',
      cancel: 'रद्द करो'
    },
    deletePaymentModal: {
      title: 'भुगतान हटाओ',
      message: 'क्या आप यह भुगतान हटाना चाहते हैं?',
      confirm: 'भुगतान हटाओ',
      cancel: 'रद्द करो'
    },
    messages: {
      loadError: 'लोनो खबर लोड नहीं हो पाई',
      pledgesLoadError: 'गिरवी सामान लोड नहीं हो पाई',
      paymentsLoadError: 'भुगतान लोड नहीं हो पाए',
      statusUpdateSuccess: 'गिरवी सामान वापस आ गई और लोनो बंद हुआ।',
      statusUpdateError: 'स्थिति नहीं बदली, कृपया फिर कोशिश करें।',
      paymentCreateSuccess: 'भुगतान सुरक्षित हो गया',
      paymentCreateError: 'भुगतान सुरक्षित नहीं हो पाया',
      paymentDeleteSuccess: 'भुगतान हटाया गया',
      paymentDeleteError: 'भुगतान हटाने में दिक्कत आई',
      paymentAmountInvalid: 'कृपया सही भुगतान रकम लिखें',
      missingBusiness: 'दुकान या लोनो की खबर नहीं मिली',
      advanceAmountInvalid: 'कृपया सही एडवांस रकम लिखो',
      advanceCreateSuccess: 'अतिरिक्त लोनो जुड़ गयो',
      advanceCreateError: 'अतिरिक्त लोनो नहीं जुड़ पायो'
    }
  },

  // Borrower Details Page - कस्टमर विवरण पृष्ठ
  borrowerDetails: {
    loading: 'कस्टमर खबर लोड हो रही है...',
    notFound: 'कस्टमर नहीं मिल्यो',
    back: 'वापस',
    backToList: 'कस्टमर सूची पर वापस',
    headerId: 'कस्टमर नंबर',
    infoTitle: 'कस्टमर खबर',
    labels: {
      fullName: 'पूरा नांव',
      fatherName: 'पिता का नांव',
      contactNumber: 'मोबाइल नंबर',
      email: 'ईमेल',
      idProofType: 'पहचान पत्र का प्रकार',
      idProofNumber: 'पहचान पत्र नंबर',
      address: 'पता',
      createdDate: 'बनने की तारीख'
    },
    documents: {
      title: 'पहचान पत्र',
      expand: 'बड़ा करें',
      none: 'कोई दस्तावेज़ नहीं'
    },
    loans: {
      title: 'लोनो का रिकॉर्ड',
      loading: 'लोनो लोड हो रहे हैं...',
      empty: 'इस कस्टमर का कोई लोनो नहीं मिल्यो',
      headers: {
        loanId: 'लोनो नंबर',
        serialNumber: 'सीरियल नंबर',
        principal: 'लोनो रकम (₹)',
        interestRate: 'ब्याज दर',
        tenure: 'अवधि',
        status: 'स्थिति',
        createdDate: 'बनने की तारीख',
        actions: 'चोन'
      },
      perMonth: 'प्रति महीना',
      months: 'महीने',
      view: 'पूरा विवरण'
    },
    messages: {
      loadError: 'कस्टमर खबर लोड नहीं हो पाई',
      loansError: 'लोनो लोड नहीं हो पाए'
    },
    modal: {
      close: 'बंद करें',
      previous: 'पिछला',
      next: 'अगला'
    }
  },

  // Pledge Details Page - गिरवी सामान विवरण पृष्ठ
  pledgeDetails: {
    loading: 'गिरवी सामान खबर लोड हो रही है...',
    notFound: 'गिरवी सामान नहीं मिली',
    back: 'वापस',
    backToList: 'गिरवी सामान सूची पर वापस',
    statusBadge: 'स्थिति',
    summaryTitle: 'गिरवी सामान सारांश',
    borrowerTitle: 'कस्टमर विवरण',
    loanTitle: 'जुड़ा लोनो',
    pledgedAmount: 'गिरवी सामान रकम',
    interestRate: 'ब्याज दर',
    pledgeDate: 'गिरवी सामान की तारीख',
    maturityDate: 'समाप्ति की तारीख',
    pledgedTo: 'कहाँ गिरवी सामान',
    interestEarned: 'जमायो ब्याज',
    totalDue: 'कुल देय',
    pledgeDuration: 'गिरवी सामान अवधि',
    interestBreakdownTitle: 'ब्याज विवरण',
    additionalDaysLabel: 'दिन',
    netProfit: 'मासिक मुनाफा',
    updateStatus: 'वापस मार्क करें',
    // Interest Breakdown
    interestBreakdown: 'ब्याज विवरण',
    calculationDetails: 'गणना का विवरण:',
    oneMonthInterest: 'महीने का ब्याज',
    additionalDaysInterest: 'अतिरिक्त दिनों का ब्याज',
    totalInterestPayable: 'कुल देय ब्याज',
    days: 'दिन',
    currentInterestTitle: 'अभी रो ब्याज',
    interestPeriod: 'अवधि',
    interestDuration: 'दिन',
    interestDue: 'देय ब्याज',
    interestPaid: 'भुगतान ब्याज',
    interestOutstanding: 'बाकी',
    interestStatus: 'स्थिति',
    interestStatusPaid: 'भुगतान',
    interestStatusUnpaid: 'बाकी',
    payInterest: 'ब्याज भुगतान',
    interestHistoryTitle: 'ब्याज भुगतान इतिहास',
    interestHistoryDate: 'तारीख',
    interestHistoryPeriod: 'अवधि',
    interestHistoryDays: 'दिन',
    interestHistoryAmount: 'रकम',
    interestHistoryStatus: 'स्थिति',
    interestPayModal: {
      title: 'गिरवी ब्याज भुगतान',
      message: 'अभी री ब्याज अवधि खातर {amount} रो भुगतान कन्फर्म करो।',
      cancel: 'रद्द करो',
      confirm: 'ब्याज भुगतान',
      paying: 'भुगतान हो रह्यो है...'
    },
    // Associated Loan
    associatedLoan: 'जुड़ा हुआ लोनो',
    loanId: 'लोनो नंबर',
    loanAmount: 'लोनो रकम',
    loanStatus: 'लोनो स्थिति',
    metalType: 'धातु का प्रकार',
    itemDescription: 'सामान का विवरण',
    viewLoan: 'लोनो देखें',
    viewFullLoanDetails: 'पूरा लोनो विवरण देखें',
    // Pledge Document
    pledgeDocument: 'गिरवी सामान दस्तावेज़',
    noDocumentAvailable: 'कोई दस्तावेज़ उपलब्ध नहीं',
    statusModal: {
      title: 'वापसी की पुष्टि',
      message: 'क्या गिरवी सामान सामान कस्टमर को वापस दे दियो है?',
      cancel: 'रद्द करो',
      confirm: 'हाँ, वापस कर दें',
      updating: 'बदला जा रहा है...'
    },
    messages: {
      loadError: 'गिरवी सामान खबर लोड नहीं हो पाई',
      loanLoadError: 'जुड़ा लोनो लोड नहीं हो पाया',
      statusSuccess: 'गिरवी सामान वापस आ गई और लोनो बंद हुआ।',
      statusError: 'स्थिति नहीं बदली, कृपया फिर कोशिश करें।',
      noBusiness: 'कोई दुकान नहीं चुनी',
      noRecords: 'कोई गिरवी सामान रिकॉर्ड नहीं मिल्यो',
      interestPaySuccess: 'गिरवी ब्याज सफलतापूर्वक भुगतान हो गयो।',
      interestPayError: 'गिरवी ब्याज भुगतान नहीं हो पायो। फिर कोशिश करो।'
    }
  },
  
  // SEO Keywords and Content - एसईओ कीवर्ड अर सामग्री
  seo: {
    // Primary Keywords - मुख्य कीवर्ड
    primaryKeywords: [
      'गोल्ड लोनो मैनेजमेंट सॉफ्टवेयर',
      'सोने रो लोनो सॉफ्टवेयर',
      'गहनों रो लोनो सिस्टम',
      'चांदी लोनो सॉफ्टवेयर',
      'सोने के बदले लोनो',
      'आभूषण लोनो प्रबंधन',
      'गिरवी लोनो सॉफ्टवेयर',
      'गिरवी सामान प्रबंधन सॉफ्टवेयर',
      'साहूकार सॉफ्टवेयर',
      'सोने री दुकान सॉफ्टवेयर',
      'गहनों रो कारोबार सॉफ्टवेयर'
    ],
    
    // Secondary Keywords - दूजा कीवर्ड
    secondaryKeywords: [
      'गोल्ड लोनो कैलकुलेटर',
      'सोने रो भाव कैलकुलेटर',
      'ब्याज कैलकुलेटर लोनो',
      'लोनो मैनेजमेंट सिस्टम',
      'कस्टमर लोनो ट्रैकिंग',
      'उधारकर्ता प्रबंधन',
      'लोनो चुकौती ट्रैकर',
      'सोने री शुद्धता कैलकुलेटर',
      '22 कैरेट सोने रो लोनो',
      '24 कैरेट सोने रो लोनो',
      '18 कैरेट सोने रो लोनो',
      'हॉलमार्क गोल्ड लोनो',
      'भारतीय गोल्ड लोनो सॉफ्टवेयर',
      'छोटो व्यापार लोनो सॉफ्टवेयर',
      'एमएसएमई लोनो सॉफ्टवेयर',
      'सूक्ष्म वित्त सॉफ्टवेयर',
      'फिर से गिरवी सॉफ्टवेयर',
      'लोनो बुक सॉफ्टवेयर',
      'खातो बही लोनो के लिए',
      'डिजिटल लोनो प्रबंधन',
      'ऑनलाइन गोल्ड लोनो',
      'सोने री दुकान सॉफ्टवेयर',
      'ज्वेलरी स्टोर लोनो सिस्टम',
      'गिरवी दुकान सॉफ्टवेयर'
    ],
    
    // Location-Based Keywords - जगह के हिसाब से कीवर्ड
    locationKeywords: [
      'जयपुर गोल्ड लोनो',
      'जोधपुर गोल्ड लोनो',
      'राजस्थान गोल्ड लोनो',
      'बीकानेर गोल्ड लोनो',
      'उदयपुर गोल्ड लोनो',
      'अजमेर गोल्ड लोनो',
      'कोटा गोल्ड लोनो',
      'भारत गोल्ड लोनो',
      'राजस्थान व्यापारो सॉफ्टवेयर',
      'मारवाड़ी व्यापारो सॉफ्टवेयर',
      'राजस्थानी साहूकार सॉफ्टवेयर',
      'मारवाड़ी साहूकार सॉफ्टवेयर'
    ],
    
    // Long-Tail Keywords - लंबा कीवर्ड
    longTailKeywords: [
      'गोल्ड लोनो रो बिजनेस कैंय मैनेज करें',
      'बेस्ट गोल्ड लोनो मैनेजमेंट सॉफ्टवेयर',
      'ज्वेलरी लोनो बिजनेस के लिए सॉफ्टवेयर',
      'सोने के लोनो के लिए डिजिटल समाधान',
      'गोल्ड लोनो कस्टमर नै कैंय ट्रैक करें',
      'ऑनलाइन गिरवी लोनो मैनेज करें',
      'गोल्ड लोनो ब्याज कैलकुलेटर',
      'साहूकार बिजनेस के लिए सॉफ्टवेयर',
      'छोटो बिजनेस के लिए लोनो प्रबंधन',
      'सोने के गिरवी सामान प्रबंधन सिस्टम',
      'सोने पर कितनो लोनो मिलै',
      'गोल्ड लोनो री ब्याज दर',
      'गहनों पर लोनो कैंय लें',
      'राजस्थान में सोने रो लोनो',
      'मारवाड़ में गोल्ड लोनो'
    ],
    
    // Meta Descriptions - मेटा विवरण
    metaDescriptions: {
      home: 'संपूर्ण गोल्ड अर सिल्वर लोनो मैनेजमेंट सॉफ्टवेयर। सोने के लोनो, गहनों के लोनो, गिरवी लोनो अर कोलैटरल नै आसानी थी मैनेज करो। भारत अर राजस्थान में गोल्ड लोनो बिजनेस, गिरवी दुकानों अर ज्वेलरी फाइनेंस कंपनियों के लिए परफेक्ट।',
      features: 'लोनो ट्रैक करो, उधारकर्ताओं नै मैनेज करो, गिरवी संभालो, ब्याज री गणना करो, रिपोर्ट जनरेट करो अर म्हारे व्यापक प्रबंधन सॉफ्टवेयर के साथ आपनो गोल्ड लोनो बिजनेस बढ़ाओ।',
      benefits: 'स्वचालित गणना, कस्टमर ट्रैकिंग, भुगतान प्रबंधन अर विस्तृत एनालिटिक्स के साथ आपनो गोल्ड लोनो बिजनेस संचालन नै सुव्यवस्थित करो। भारत भर के बिजनेस थी विश्वसनीय।'
    },
    
    // Page Titles - पेज शीर्षक
    pageTitles: {
      home: 'गोल्ड लोनो मैनेजमेंट सॉफ्टवेयर | ज्वेलरी लोनो सिस्टम | बेस्ट लोनो सॉफ्टवेयर',
      dashboard: 'लोनो डैशबोर्ड | गोल्ड लोनो, कस्टमर अर भुगतान ट्रैक करो',
      loans: 'गोल्ड लोनो मैनेज करो | ज्वेलरी लोनो ट्रैकिंग | लोनो प्रबंधन',
      borrowers: 'कस्टमर मैनेजमेंट | उधारकर्ता ट्रैकिंग | गोल्ड लोनो ग्राहक',
      collateral: 'गिरवी सामान प्रबंधन | प्लेज ट्रैकिंग | री-प्लेजिंग सिस्टम',
      analytics: 'लोनो एनालिटिक्स | बिजनेस रिपोर्ट | लाभप्रदता विश्लेषण',
      settings: 'गोल्ड रेट सेटिंग्स | ब्याज दरें | लोनो कॉन्फ़िगरेशन'
    }
  },
  
  profile: {
    businessProfile: 'व्यवसाय प्रोफ़ाइल',
    editBusinessProfile: 'व्यवसाय प्रोफ़ाइल बदलो',
    businessName: 'व्यवसाय नांव',
    contactNumber: 'संपर्क नंबर',
    businessAddress: 'व्यवसाय पता',
    noLogo: 'कोई लोगो नहीं',
    uploading: 'अपलोड थाय रह्यो...',
    change: 'बदलो',
    upload: 'अपलोड करें',
    imageFormat: 'PNG, JPG अधिकतम 5MB',
    cancel: 'रद्द करो',
    saveBusinessProfile: 'व्यवसाय प्रोफ़ाइल सहेजें',
    saving: 'सहेजा जा रहा है...',
    
    userProfile: 'उपयोगकर्ता प्रोफ़ाइल',
    editProfile: 'प्रोफ़ाइल बदलो और पासवर्ड बदलो',
    firstName: 'पहला नांव',
    lastName: 'अंतिम नांव',
    email: 'ईमेल',
    role: 'भूमिका',
    previousPassword: 'पुराना पासवर्ड',
    newPassword: 'नया पासवर्ड',
    enterCurrentPassword: 'अपना वर्तमान पासवर्ड दर्ज करें',
    enterNewPassword: 'अपना नया पासवर्ड दर्ज करें',
    saveChanges: 'परिवर्तन सहेजें',
    
    logout: 'बाहर आवो',
    
    errors: {
      invalidImage: 'कृपया एक वैध छवि फ़ाइल चुनें।',
      imageSizeLimit: 'छवि का आकार 5MB से कम होना चाहिए।',
      uploadFailed: 'लोगो अपलोड करने में विफल',
      businessIdNotFound: 'व्यवसाय ID नहीं मिली। कृपया पृष्ठ रीफ्रेश करें।',
      contactRequired: 'संपर्क नंबर आवश्यक है।',
      addressRequired: 'व्यवसाय पता आवश्यक है।',
      updateBusinessFailed: 'व्यवसाय प्रोफ़ाइल अपडेट करने में विफल। कृपया पुनः प्रयास करें।',
      updateBusinessError: 'व्यवसाय प्रोफ़ाइल अपडेट करने में त्रुटि हुई। कृपया पुनः प्रयास करें।',
      userIdNotFound: 'उपयोगकर्ता ID नहीं मिली। कृपया फिर से लॉगिन करें।',
      passwordFieldsRequired: 'पासवर्ड बदलने के लिए पुराना और नया पासवर्ड दोनों आवश्यक हैं।',
      passwordMinLength: 'नया पासवर्ड कम से कम 6 अक्षरों का होना चाहिए।',
      updateProfileFailed: 'प्रोफ़ाइल अपडेट करने में विफल। कृपया पुनः प्रयास करें।',
      updateProfileError: 'प्रोफ़ाइल अपडेट करने में त्रुटि हुई। कृपया पुनः प्रयास करें।'
    }
  }
};
